export default "__VITE_ASSET__3bb1a6e7__"